import { render, staticRenderFns } from "./table-simple.vue?vue&type=template&id=a504bc54&scoped=true&"
import script from "./table-simple.vue?vue&type=script&lang=js&"
export * from "./table-simple.vue?vue&type=script&lang=js&"
import style0 from "./table-simple.vue?vue&type=style&index=0&id=a504bc54&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a504bc54",
  null
  
)

export default component.exports